import React from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { Container, Col, Row, CardImg, Card, CardBody } from "reactstrap";
import { SETTINGS_FOUR_ITEM } from "constants/sliderSetting";
import "assets/styles/components/iconProperty.scss";
import "assets/styles/components/variantProperty.scss";
import "assets/styles/components/slider.scss";

export default function Advantages() {
  const { t } = useTranslation();
  const settings = SETTINGS_FOUR_ITEM;
  const sliderContent = [
    {
      icon: "sheild",
      content:
        "Comfortable with your imaginary market, When it comes to buying and selling digital currency, security comes first",
      title: "Safe and smart",
    },
    {
      icon: "chart",
      content:
        "In the Coinnik Market, you can buy and sell 34 digital currencies to have a more diverse portfolio.",
      title: "The most currency among Iranian markets",
    },
    {
      icon: "wallet",
      content:
        "Coinnik Market wallet has no limit to deposit and withdraw digital currency / Rials as much as you need.",
      title: "Safe and unlimited wallet",
    },
    {
      icon: "hand",
      content:
        "At Coinnik Market, the simple and user-friendly buying and selling process is designed to make you feel comfortable.",
      title: "Easy and fast",
    },
  ];

  const boxSlider = () =>
    sliderContent.map((item) => (
      <Row>
        <Col xs="12">
          <CardItem
            icon={item.icon}
            title={t(item.title)}
            content={t(item.content)}
          />
        </Col>
      </Row>
    ));
  return (
    <Card className="card  mt-4">
      <Container className="py-6">
        <div className="d-flex flex-column justify-content-center align-items-center mb-5">
          <span className="text-warning-light fw-medium fs-6 pb-2">
            {t("Attributes")}
          </span>
          <span className="fs-5 text-primary-light fw-bold">
            {t("Why Coinnik Market?")}
          </span>
        </div>
        <Slider {...settings}>{boxSlider()}</Slider>
      </Container>
    </Card>
  );
}

const CardItem = ({ icon, content, title }: any) => (
  <div className="d-flex flex-column justify-content-center align-items-center">
    <img
      height="51"
      src={require(`assets/image/${icon}.png`).default}
      className=""
    />
    <span className="fs-6 text-center  fw-medium text-secondary-seven-light my-4">
      {title}
    </span>
    <p className="fs-6 text-center text-secondary-three-light">{content}</p>
  </div>
);
